export default __webpack_public_path__ + "static/media/download.cc641a8e.svg";